import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://bullyproofmylife.com';

const ABOUT_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Contractor Took My Money and Disappeared? How I Fought Back (Legally)",
  "description": "A contractor walked off with $4,500 of my money. Here's the legal loophole I used to make the problem disappear—and how any homeowner can use the same move.",
  "author": {
    "@type": "Person",
    "name": "Matt Theriault"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Bully Proof My Life",
    "url": `${SITE_URL}/`
  },
  "url": `${SITE_URL}/about`,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `${SITE_URL}/about`
  }
};

const HOME_TITLE = "Legal Protection for Homeowners & Landlords | Bully Proof My Life";
const HOME_DESC = "Get affordable legal protection for homeowners and landlords for about $30/month. Use real attorneys to fight shady contractors, HOA boards and insurance bullies.";

export default function AboutPageMeta() {
  useEffect(() => {
    // Title
    document.title = "Contractor Took My Money and Disappeared? How I Fought Back (Legally)";

    // Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "A contractor walked off with $4,500 of my money. Here's the legal loophole I used to make the problem disappear—and how any homeowner can use the same move.");

    // Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'contractor took my money what can I do, shady contractor stole my money, legal help for contractor dispute, how to fight a bad contractor legally, lawyer demand letter to contractor');

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_URL}/about`);

    // OG title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Contractor Took My Money and Disappeared? How I Fought Back (Legally)');

    // OG description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', "A contractor walked off with $4,500 of my money. Here's the legal loophole I used to make the problem disappear—and how any homeowner can use the same move.");

    // OG URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', `${SITE_URL}/about`);

    // Twitter title
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (!twitterTitle) {
      twitterTitle = document.createElement('meta');
      twitterTitle.setAttribute('name', 'twitter:title');
      document.head.appendChild(twitterTitle);
    }
    twitterTitle.setAttribute('content', 'Contractor Took My Money and Disappeared? How I Fought Back (Legally)');

    // Twitter description
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (!twitterDescription) {
      twitterDescription = document.createElement('meta');
      twitterDescription.setAttribute('name', 'twitter:description');
      document.head.appendChild(twitterDescription);
    }
    twitterDescription.setAttribute('content', "A contractor walked off with $4,500 of my money. Here's the legal loophole I used to make the problem disappear—and how any homeowner can use the same move.");

    // Schema.org Article JSON-LD (unique id so it doesn't collide with home page schemas)
    const SCHEMA_ID = 'schema-about-article';
    let scriptTag = document.getElementById(SCHEMA_ID) as HTMLScriptElement | null;
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = SCHEMA_ID;
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(ABOUT_SCHEMA);

    // Cleanup: restore home page meta on unmount
    return () => {
      document.title = HOME_TITLE;

      const desc = document.querySelector('meta[name="description"]');
      if (desc) desc.setAttribute('content', HOME_DESC);

      const can = document.querySelector('link[rel="canonical"]');
      if (can) can.setAttribute('href', `${SITE_URL}/`);

      const ogt = document.querySelector('meta[property="og:title"]');
      if (ogt) ogt.setAttribute('content', HOME_TITLE);

      const ogd = document.querySelector('meta[property="og:description"]');
      if (ogd) ogd.setAttribute('content', HOME_DESC);

      const ogu = document.querySelector('meta[property="og:url"]');
      if (ogu) ogu.setAttribute('content', `${SITE_URL}/`);

      const twt = document.querySelector('meta[name="twitter:title"]');
      if (twt) twt.setAttribute('content', HOME_TITLE);

      const twd = document.querySelector('meta[name="twitter:description"]');
      if (twd) twd.setAttribute('content', HOME_DESC);

      const schema = document.getElementById(SCHEMA_ID);
      if (schema && schema.parentNode) schema.parentNode.removeChild(schema);
    };
  }, []);

  return null;
}